import { render } from "./courseTitleList.vue?vue&type=template&id=53ebfbf7&scoped=true"
import script from "./courseTitleList.vue?vue&type=script&lang=js"
export * from "./courseTitleList.vue?vue&type=script&lang=js"

import "./courseTitleList.vue?vue&type=style&index=0&id=53ebfbf7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ebfbf7"]])

export default __exports__